import React, { useRef, useState, useEffect, forwardRef, useImperativeHandle } from "react";
import data from "emoji-mart/data/apple.json";
import { NimblePicker } from "emoji-mart";
import cx from "classnames";
import "emoji-mart/css/emoji-mart.css";

type Props = { onSelect: (emoji) => void };

const EmojiPicker = ({ onSelect }: Props, ref: React.Ref<typeof EmojiPicker>) => {
	const node = useRef<HTMLDivElement>(null as HTMLDivElement);
	const button = useRef<HTMLDivElement>(null as HTMLDivElement);
	const [isOpen, setOpen] = useState(false);

	useImperativeHandle(ref, () => ({
		close: () => {
			setOpen(false);
		},
	}));

	useEffect(() => {
		if (isOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			document.removeEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isOpen]);

	const handleClickOutside = e => {
		if (e.target.tagName === "TEXTAREA" || node.current.contains(e.target) || e.target === button.current) {
			return;
		}

		setOpen(false);
	};

	const toggleEmoji = () => {
		setOpen(!isOpen);
	};

	const className = cx("emojiInput", { open: isOpen });
	return (
		<>
			<div className={className} ref={node}>
				<NimblePicker set="apple" data={data} showPreview={false} showSkinTones={false} onSelect={onSelect} />
			</div>
			<div className="emojiButton" onClick={toggleEmoji} ref={button} />
		</>
	);
};

export default forwardRef<typeof EmojiPicker, Props>(EmojiPicker);
